exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/myLoans/modals/myLoansModal/myLoansModal.scss
// module id = 1981
// module chunks = 0